(function() {
  const SHADE_GROUPS = {
    red:     [808, 811, 813, 818, 835, 836],
    maroon:  [802, 810, 817, 822, 833, 832],
    magenta: [801, 807, 809, 804, 806, 812, 819, 824, 825, 826, 828, 834],
    brown:   [803, 814, 805, 815, 816, 820, 823, 821, 827, 829, 830, 831]
  };

  const TAB_LABELS = {
    all:     'All',
    red:     'Red',
    maroon:  'Maroon',
    magenta: 'Pink / Magenta',
    brown:   'Nude / Brown'
  };

  let activeGroup = 'all';

  function getColorNumber(str) {
    const match = (str || '').match(/\b(8[0-3][0-9])\b/);
    return match ? parseInt(match[1]) : null;
  }

  function getShadeGroup(num) {
    for (const [group, nums] of Object.entries(SHADE_GROUPS)) {
      if (nums.includes(num)) return group;
    }
    return null;
  }

  function applyFilter(swatchItems, group) {
    swatchItems.forEach(item => {
      item.style.display = (group === 'all' || item.dataset.blGroup === group) ? '' : 'none';
    });
  }

  function inject() {
    const swatchContainer = document.querySelector('SHT-PRD-VARIANT-SWTCH');
    if (!swatchContainer) return false;

    const swatchItems = swatchContainer.querySelectorAll('.product-swatches__item');
    if (!swatchItems.length) return false;

    const existing = document.getElementById('bl-tab-bar');
    if (existing && existing.nextSibling === swatchContainer) {
      applyFilter(swatchItems, activeGroup);
      return true;
    }

    if (existing) existing.remove();

    const groupsPresent = new Set();
    let hasAnyGroup = false;

    swatchItems.forEach(item => {
      const colorNum = getColorNumber(item.dataset.value || '');
      const group = colorNum ? getShadeGroup(colorNum) : null;
      item.dataset.blGroup = group || 'other';
      if (group) { groupsPresent.add(group); hasAnyGroup = true; }
    });

    if (!hasAnyGroup) return false;

    applyFilter(swatchItems, activeGroup);

    const tabBar = document.createElement('div');
    tabBar.id = 'bl-tab-bar';

    ['all', ...([...groupsPresent].sort())].forEach(group => {
      const btn = document.createElement('button');
      btn.className = 'bl-tab' + (group === activeGroup ? ' bl-tab--active' : '');
      btn.textContent = TAB_LABELS[group] || group;
      btn.dataset.group = group;
      btn.type = 'button';
      btn.addEventListener('click', () => {
        activeGroup = group;
        tabBar.querySelectorAll('.bl-tab').forEach(b =>
          b.classList.toggle('bl-tab--active', b.dataset.group === group)
        );
        applyFilter(swatchItems, group);
      });
      tabBar.appendChild(btn);
    });

    swatchContainer.parentNode.insertBefore(tabBar, swatchContainer);
    injectStyles();
    return true;
  }

  function injectStyles() {
    if (document.getElementById('bl-swatch-styles')) return;
    const style = document.createElement('style');
    style.id = 'bl-swatch-styles';
    style.textContent = `
      #bl-tab-bar {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
        margin-top: 4px;
      }
      .bl-tab {
        padding: 6px 16px;
        border: 1.5px solid #ddd;
        background: #fff;
        border-radius: 20px;
        font-size: 13px;
        cursor: pointer;
        color: #555;
        transition: all 0.2s;
        font-family: inherit;
        letter-spacing: 0.3px;
        line-height: 1;
      }
      .bl-tab:hover { border-color: #333; color: #333; }
      .bl-tab--active {
        background: #222;
        color: #fff !important;
        border-color: #222;
      }
    `;
    document.head.appendChild(style);
  }

  function startPersistentGuard() {
    setInterval(() => {
      const tabBar = document.getElementById('bl-tab-bar');
      const container = document.querySelector('SHT-PRD-VARIANT-SWTCH');
      if (!container) return;
      if (!tabBar || !tabBar.isConnected) {
        inject();
      }
    }, 300);
  }

  function init() {
    inject();
    startPersistentGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();